/* Step 13 · P3 · S5 (owner, 03-Nov-2026): the Audit trail screen shows one page of the filtered trail (100 rows); the filters and
   the search run on the server over the whole trail, so they work across every page. The export stays the full filtered trail. */
import React from "react";
import { Button } from "@/components/ui/button";

export const W13_PAGE_SIZE = 100;

function ltr(s) { return `⁨${s}⁩`; }

export default function AuditTrailPager({ t, page, pages, count, pageSize, onPage }) {
  const p = Math.max(1, Number(page) || 1);
  const n = Number(count) || 0;
  const size = Number(pageSize) || W13_PAGE_SIZE;
  const last = Math.max(1, Number(pages) || 1);
  const from = n ? (p - 1) * size + 1 : 0;
  const to = Math.min(n, p * size);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 text-[11px] text-muted-foreground" data-testid="w13-pager">
      <span data-testid="w13-pager-range">
        {t("w13Pager.range").replace("{from}", ltr(String(from))).replace("{to}", ltr(String(to))).replace("{n}", ltr(String(n)))}
        {" · "}
        <span data-testid="w13-pager-page">{t("w13Pager.page").replace("{p}", ltr(String(p))).replace("{pages}", ltr(String(last)))}</span>
      </span>
      {last > 1 && (
        <span className="flex gap-1">
          <Button variant="outline" size="sm" disabled={p <= 1} onClick={() => onPage(1)} data-testid="w13-pager-first">{t("w13Pager.first")}</Button>
          <Button variant="outline" size="sm" disabled={p <= 1} onClick={() => onPage(p - 1)} data-testid="w13-pager-prev">{t("w13Pager.prev")}</Button>
          <Button variant="outline" size="sm" disabled={p >= last} onClick={() => onPage(p + 1)} data-testid="w13-pager-next">{t("w13Pager.next")}</Button>
          <Button variant="outline" size="sm" disabled={p >= last} onClick={() => onPage(last)} data-testid="w13-pager-last">{t("w13Pager.last")}</Button>
        </span>
      )}
    </div>
  );
}
